/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 14:47:00
 * @name: 工单管理-确认收到零件
 * @Description: 工单管理-确认收到零件
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\confirmParts.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
]